import React from 'react';
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog.js';
import { withTranslation } from 'react-i18next';
import { Check, CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox, Close } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button } from '@mui/material';
import styles from './Step3.module.scss';

class Step3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            torgid_category_id: [],
            selectedCategoriesCount: {},
            dialogOpen: false,
            dialogMessage: null,
            modalOpen: false,
            modalParentId: null,
        };
    }

    componentDidMount() {
        if (this.props.offerData.torgid_offer_category_nxns) {
            const activeCategories = [];
            const selectedCategoriesCount = {};
            this.props.offerData.torgid_offer_category_nxns.forEach((obj) => {
                if (obj.torgid_offer_category) {
                    activeCategories.push(obj.torgid_offer_category_id);
                    const pid = obj.torgid_offer_category.parent_id;
                    selectedCategoriesCount[pid] = (selectedCategoriesCount[pid] || 0) + 1;
                }
            });
            this.setState({ torgid_category_id: activeCategories, selectedCategoriesCount });
        }
    }

    sendState() {
        return this.state;
    }

    hideAlert = () => this.setState({ dialogOpen: false, dialogMessage: null });

    isValidated() {
        if (this.state.torgid_category_id.length === 0) {
            this.setState({ dialogOpen: true, dialogMessage: 'Vinsamlega veldu a.m.k. einn flokk.' });
            return false;
        }
        return true;
    }

    openModal = (parentId) => {
        this.setState({ modalOpen: true, modalParentId: parentId });
    };

    closeModal = () => {
        this.setState({ modalOpen: false });
    };

    handleModalExited = () => {
        this.setState({ modalParentId: null });
    };

    toggleSubcategory = (id, parentId) => {
        const { torgid_category_id, selectedCategoriesCount } = this.state;
        const idx = torgid_category_id.indexOf(id);
        const newIds = [...torgid_category_id];
        const newCounts = { ...selectedCategoriesCount };

        if (idx === -1) {
            newIds.push(id);
            newCounts[parentId] = (newCounts[parentId] || 0) + 1;
        } else {
            newIds.splice(idx, 1);
            newCounts[parentId] = Math.max((newCounts[parentId] || 1) - 1, 0);
        }

        this.setState({ torgid_category_id: newIds, selectedCategoriesCount: newCounts });
    };

    toggleAllSubcategories = (children, parentId) => {
        const { torgid_category_id } = this.state;
        const childIds = children.map((c) => c.id);
        const allSelected = childIds.every((id) => torgid_category_id.includes(id));
        const newCounts = { ...this.state.selectedCategoriesCount };

        let newIds;
        if (allSelected) {
            newIds = torgid_category_id.filter((id) => !childIds.includes(id));
            newCounts[parentId] = 0;
        } else {
            newIds = [...new Set([...torgid_category_id, ...childIds])];
            newCounts[parentId] = childIds.length;
        }

        this.setState({ torgid_category_id: newIds, selectedCategoriesCount: newCounts });
    };

    getTopLevelCategories() {
        const { categories } = this.props;
        if (!categories || !categories[0] || !categories[0].children) return [];
        return categories[0].children;
    }

    getSubcategories(parentId) {
        const { categories } = this.props;
        const found = categories.find((item) => item.parent_id == parentId);
        if (found) return found.children || [];
        const topLevel = this.getTopLevelCategories();
        const cat = topLevel.find((c) => c.id == parentId);
        return cat?.children || [];
    }

    render() {
        const { currentLang, t } = this.props;
        const { torgid_category_id, selectedCategoriesCount, modalOpen, modalParentId } = this.state;

        const topLevel = this.getTopLevelCategories();
        const totalSelected = torgid_category_id.length;

        const modalChildren = modalParentId ? this.getSubcategories(modalParentId) : [];
        const modalParent = topLevel.find((c) => c.id === modalParentId);
        const modalChildIds = modalChildren.map((c) => c.id);
        const modalSelectedCount = modalChildIds.filter((id) => torgid_category_id.includes(id)).length;
        const allModalSelected = modalSelectedCount === modalChildIds.length && modalChildIds.length > 0;
        const someModalSelected = modalSelectedCount > 0 && !allModalSelected;

        return (
            <div className={styles.container}>
                <ConfirmDialog
                    open={!!this.state.dialogOpen}
                    title={t('missing_information')}
                    message={this.state.dialogMessage}
                    type="warning"
                    onConfirm={() => this.hideAlert()}
                    confirmText={t('ok')}
                />

                <div className={`${styles.selectionSummary} ${totalSelected > 0 ? styles.selectionSummaryActive : ''}`}>
                    {totalSelected === 0 ? (
                        <span className={styles.selectionSummaryEmpty}>{t('no_selection_yet')}</span>
                    ) : (
                        <span className={styles.selectionSummaryLabel}>
                            {totalSelected}{' '}
                            {totalSelected % 10 === 1 && totalSelected % 100 !== 11
                                ? t('category_selected_singular')
                                : t('categories_selected')}
                        </span>
                    )}
                </div>

                <h4 className={styles.sectionTitle}>{t('categories')}</h4>

                <div className={styles.card}>
                <div className={styles.categoriesGrid}>
                    {topLevel.map((cat) => {
                        const count = selectedCategoriesCount[cat.id] || 0;
                        const isSelected = count > 0;
                        const lang = currentLang === 'en' && cat.name_en ? cat.name_en : cat.name;

                        return (
                            <div
                                key={cat.id}
                                data-testid={`offer-category-${cat.id}`}
                                className={`${styles.categoryCard} ${isSelected ? styles.categoryCardSelected : ''}`}
                                onClick={() => this.openModal(cat.id)}
                            >
                                {isSelected && (
                                    <div className={styles.countBadge}>{count}</div>
                                )}
                                {cat.logo && (
                                    <img src={cat.logo} alt={lang} className={styles.categoryLogo} />
                                )}
                                <span className={`${styles.categoryName} ${isSelected ? styles.categoryNameSelected : ''}`}>
                                    {lang}
                                </span>
                            </div>
                        );
                    })}
                </div>
                </div>

                <Dialog
                    open={modalOpen}
                    onClose={this.closeModal}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{ style: { borderRadius: 12 } }}
                    TransitionProps={{ onExited: this.handleModalExited }}
                >
                    <DialogTitle
                        style={{
                            padding: '16px 20px 12px',
                            borderBottom: '1px solid var(--spara-border, #f0f0f0)',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                {modalParent?.logo && (
                                    <img
                                        src={modalParent.logo}
                                        alt=""
                                        style={{ width: 28, height: 28, objectFit: 'contain' }}
                                    />
                                )}
                                <span
                                    style={{
                                        fontWeight: 600,
                                        fontSize: '1rem',
                                        color: 'var(--spara-text-strong, #333)',
                                    }}
                                >
                                    {modalParent
                                        ? currentLang === 'en' && modalParent.name_en
                                            ? modalParent.name_en
                                            : modalParent.name
                                        : ''}
                                </span>
                                {modalSelectedCount > 0 && (
                                    <span className={styles.modalSelectedCount}>{modalSelectedCount}</span>
                                )}
                            </div>
                            <IconButton size="small" onClick={this.closeModal}>
                                <Close fontSize="small" />
                            </IconButton>
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ padding: '16px 20px 20px' }}>
                        {modalChildren.length > 0 && (
                            <>
                                <div className={styles.modalSelectAllRow}>
                                    <button
                                        type="button"
                                        className={styles.selectAllBtn}
                                        onClick={() => this.toggleAllSubcategories(modalChildren, modalParentId)}
                                    >
                                        {allModalSelected ? (
                                            <CheckBox className={styles.checkboxIcon} style={{ color: '#4caf50' }} />
                                        ) : someModalSelected ? (
                                            <IndeterminateCheckBox className={styles.checkboxIcon} style={{ color: '#4caf50' }} />
                                        ) : (
                                            <CheckBoxOutlineBlank className={styles.checkboxIcon} />
                                        )}
                                        <span className={styles.selectAllLabel}>{t('select_all')}</span>
                                    </button>
                                </div>

                                <div className={styles.subcategoriesGrid}>
                                    {modalChildren.map((sub) => {
                                        const isSelected = torgid_category_id.includes(sub.id);
                                        const lang = currentLang === 'en' && sub.name_en ? sub.name_en : sub.name;
                                        return (
                                            <div
                                                key={sub.id}
                                                data-testid={`offer-subcategory-${sub.id}`}
                                                className={`${styles.subcategoryCard} ${isSelected ? styles.subcategoryCardSelected : ''}`}
                                                onClick={() => this.toggleSubcategory(sub.id, modalParentId)}
                                            >
                                                {isSelected && (
                                                    <div className={styles.subCheckBadge}>
                                                        <Check style={{ fontSize: 13 }} />
                                                    </div>
                                                )}
                                                {sub.icon && (
                                                    <img src={sub.icon} alt={lang} className={styles.subcategoryIcon} />
                                                )}
                                                <span className={`${styles.subcategoryName} ${isSelected ? styles.subcategoryNameSelected : ''}`}>
                                                    {lang}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions
                        style={{
                            padding: '12px 20px',
                            borderTop: '1px solid var(--spara-border, #f0f0f0)',
                        }}
                    >
                        <Button
                            variant="contained"
                            data-testid="offer-category-modal-ok"
                            onClick={this.closeModal}
                            style={{ background: '#de2c48', color: 'white', borderRadius: 8, textTransform: 'none', fontWeight: 600 }}
                        >
                            {t('ok')}
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}

export default withTranslation('', { withRef: true })(Step3);
